import { parseRecentOrders } from "lib/recentOrders";

export const getRecentOrders = async (recentApi) => {
  try {
    const response = await recentApi?.get();
    return parseRecentOrders(response.data)
  } catch (error) {
    console.log('Get Recent Orders Error: ', error);
  }
};
